import i18n from '@/i18n'

export function getTranslationOrUndefined (key) {
    if (i18n.te(key)) {
        const translated = i18n.t(key)

        if (translated && translated !== 'null') {
            return translated
        } else {
            return undefined
        }
    } else {
        return undefined
    }
}
export const makeFirstLetterInLowerCase = (str) => str.charAt(0).toLowerCase() + str.slice(1)

export function makePrefixForTranslation (name, prefix, suffix = '') {
    return String(i18n.t(`${prefix}.${makeFirstLetterInLowerCase(name)}${suffix}`))
}

export function getLayoutConfigParameterTranslation (name) {
    const prefix = 'layout.config'
    return String(i18n.t(`${prefix}.${makeFirstLetterInLowerCase(name)}`))
}
export function getLayoutConfigParameterInfoTranslation (name, suffix = 'info') {
    const prefix = 'layout.config'
    return String(i18n.t(`${prefix}.${makeFirstLetterInLowerCase(name)}.${suffix}`))
}
